'use client';

import type { ReactNode } from 'react';

import type { BaseComponentProps } from '../../base-component.types';
import { CloseButton, ResourceBar } from '../../resource';
import type { CloseButtonProps } from '../../resource';
import { TimeLimit } from './TimeLimit';

import styles from './TitleBar.module.scss';

type TitleBarProps = BaseComponentProps & {
  /** The whole seconds left; nothing at all puts no clock on the bar. */
  secondsLeft?: number;
  title: string;
  /** Sits with the clock and the close button, to the left of both. */
  actions?: ReactNode;
  /** How leaving is offered. Left out, the bar carries no way out at all. */
  close?: CloseButtonProps;
};

/** The bar a resource that names itself is topped with — an index, a form. */
function TitleBar({
  style,
  className,
  secondsLeft,
  title,
  actions,
  close,
  testId,
}: TitleBarProps) {
  return (
    <ResourceBar
      style={style}
      className={className}
      edge="top"
      layout="split"
      testId={testId}
      start={<div className={styles['text']}>{title}</div>}
      end={
        <>
          {actions}
          <TimeLimit seconds={secondsLeft} />
          {close && <CloseButton {...close} />}
        </>
      }
    />
  );
}

export { TitleBar };
